module.exports = __webpack_public_path__ + "img/qtum.ef050ffe.svg";